
<div class="publish-container-wrap" :style="titleStyle">

  <div v-if="isConnectSite" class="connect-site-wrap" data-id-connect-element="connect-site">
    <cvt-card class="connect-site-card">
      <h3 class="cs-heading" data-id-connect-text="connect-your-site">Connect your site</h3>
      
      <div class="cs-btn-input-wrap">

        <div class="cs-input-wrap">
          <label for="cs-connection-url-input" class="cs-input-label">Enter your site URL</label>
          <cvt-input
            id="cs-connection-url-input"
            type="text"
            :value="''"
            :clearable="true"
            :placeholder="'https://'"
          />
          <div class="cs-icon-note-wrap">
            <cvt-icon
              class="cs-input-icon"
              icon="cvt-icon-circle-info" 
              />
            <small class="cs-input-note" >
              Please provide the root URL of your website where you wish to install the pop-up
            </small>
          </div>
        </div>

        <div class="cs-connect-btn-wrap">
          <cvt-button
            class="cs-connect-btn"
            :text="'Connect'"
            :size="'lg'"
            :icon="'fal fa-link'"
            :color="'primary'"
            :outlined="true"
            @click="connectAction"
          />
        </div>

      </div>
    </cvt-card>
  </div>

  <div v-if="isInstallation" class="connect-script-wrap" data-id-connect-element="copy-code">
    <cvt-card class="connect-script-card">
      <cvt-collapse :accordion="true" :prepend-chevron="false">
        <cvt-collapse-item title="Manual Install" name="Manual Install" :initial-active="true" header-class="cvt-collapse-item-header">
          
          <div class="csr-step-one-wrap">
            <p class="csr-code-heading">
              Insert code into every page of your site, before 
              <span class="csr-code-heading-span">body</span> 
              tag
            </p>

            <div class="csr-code-text-wrap">
              <p class="csr-code-text"> {{script}} </p>
            </div>
          </div>

        </cvt-collapse-item>
        <cvt-collapse-item title="Google Tag Manager" name="Google Tag Manager" header-class="cvt-collapse-item-header">
          
          <div class="csr-step-two-wrap">
            <ol class="csr-ol-wrap">
              <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_one") }}</li>
              <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_two") }}</li>
              <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_three") }}</li>
            </ol>
            <a class="csr-ol-link" href="#">Connect via Google Tag Manager</a>
          </div>

        </cvt-collapse-item>
      </cvt-collapse>
    </cvt-card>
    <cvt-button
      class="code-added-btn"
      :text="'I Have Added The Code To My Site'"
      :size="'md'"
      :icon="'cvt-icon-phone'"
      :color="'primary'"
      :outlined="false"
      :prepend="false"
       @click="installationAction"
    />
  </div>
  
  <cvt-publish-card
    v-if="isPublishing"
    data-id-connect-element="publish-card"
    class="publish-card-wrap"
    :loading="loading"
    :published="false"
    :disabled="false"
    thumbnail="loading"
    :special-style="publishBtnStyle"
    @publish="publishPopup($event)"
    @republish="publishPopup($event)"
  />

</div>
